export default "__VITE_ASSET__BkHw78$O__"